export const signUpFormConfig = {
    name: 'SignUpForm',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/d38a45a4dd9090217e1d99127cc181a1.svg',
    inputs: [
        {
            name: 'googleSSOEnabled',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'facebookSSOEnabled',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'microsoftSSOEnabled',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'hideFieldsUntilFocus',
            type: 'boolean',
            defaultValue: true,
        },
    ],
};
//# sourceMappingURL=config.js.map